






















































































































































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import moment from "moment";
import _ from "lodash";
import MyForm from "@/mixins/form";

import GroundOrdered from "./ground_ordered.vue";
import GroundOrderedEdit from "./ground_ordered_edit.vue";
import GroundOrderedDelete from "./ground_ordered_delete.vue";

import CloseList from "./close.vue";

import EventItem from "./EventItem.vue";

@Component({
  components: {
    GroundOrdered,
    GroundOrderedEdit,
    GroundOrderedDelete,
    CloseList,
    EventItem
  }
})
export default class extends Mixins(MyForm) {
  @Prop() stadiumId!: number;

  @Prop() stadiumGrounds!: any[];

  allowHalfAnHour = false;

  stadiumGrounds1: any[] = [];

  orderedModalVisible = false;

  orderedEditModalVisible = false;

  orderedDeleteModalVisible = false;

  closeListModalVisible = false;

  resources: any[] = [];

  orderedId = "";

  dayEvents: any[] = [];

  monthEvents: any[] = [];

  eventsCount: any = {};

  curdate: string = moment().format("YYYY-MM-DD");

  async loadStadiumSettings() {
    const res = await this.$store.dispatch("stadium/settingDetail", {
      stadium_id: this.stadiumId
    });
    if (res && res.Data) {
      this.allowHalfAnHour = res.Data.is_half_time === "1";
    }
  }

  handleDateSelect(selectInfo: any) {
    console.log(selectInfo);
  }

  async eventClick(info: any) {
    // console.log(info);
    const eventObj = info.event;
    // console.log(eventObj)

    if (eventObj.url) {
      this.$confirm({
        title: "确认信息",
        content: `点击${eventObj.title}\n将在新窗口打开${eventObj.url}`,
        onOk: () => {
          window.open(eventObj.url);
        }
      });
      info.jsEvent.preventDefault(); // prevents browser from following link in current tab.
    } else {
      // window.alert('Clicked ' + eventObj.title);
      if (eventObj.title === "占场") {
        this.showOrderedEditModal(eventObj.id);
      } else {
        this.$message.error("这边只能删除占场的");
      }
    }
  }

  showOrderedModal() {
    this.orderedModalVisible = true;
  }

  hideOrderedModal() {
    this.loadData11();
    this.orderedModalVisible = false;
  }

  showOrderedEditModal(id: string) {
    this.orderedId = id;
    this.orderedEditModalVisible = true;
  }

  hideOrderedEditModal() {
    this.loadData11();
    this.orderedEditModalVisible = false;
  }

  showOrderedDeleteModal() {
    this.orderedDeleteModalVisible = true;
  }

  hideOrderedDeleteModal() {
    this.loadData11();
    this.orderedDeleteModalVisible = false;
  }

  showCloseListModal() {
    this.closeListModalVisible = true;
  }

  hideCloseListModal() {
    this.loadData11();
    this.closeListModalVisible = false;
  }

  async loadEvents(info: any) {
    const res = await this.$store.dispatch("stadium/groundEvents", {
      stadium_id: this.stadiumId,
      start_time: moment(info.start).format("YYYY-MM-DD HH:mm:ss"),
      end_time: moment(info.end).format("YYYY-MM-DD HH:mm:ss")
    });

    if (res && res.Data) {//是否有占场
      const data: any = res.Data.map((itm: any) => {
        // itm.textColor = "white";
        // itm.borderColor = "#d9d9d9";

        itm.color = "green";

        // let title: string = itm.title;
        if (itm.order_type == 3) {
          itm.color = "red";
        }

        if (itm.block_id > 0) {
          itm.title += "|包场";
          itm.color = "purple";
        }

        if (itm.deal_by === "2") {
          itm.title += "|手动";
          itm.color = "lightgrey";
        }

        if (itm.type === "7") {
          itm.title += "|智能";
          itm.color = "darkgreen";
        }

        if (itm.from_source === "1") {
          itm.title += "|活动";
          itm.color = "lightgreen";
        }

        if (itm.type === "1" && itm.from_source === "3") {
          itm.title += "|延时";
          itm.color = "red";
        }

        if (itm.from_source === "6") {
          itm.title += "|微信";
        }

        if (itm.type === "1" && itm.from_source === "2") {
          itm.title += "|提前";
          itm.color = "red";
        }

        if (itm.idle_extend_bill > 0) {
          itm.title += "|空场";
          itm.color = "red";
        }

        if (itm.curator_red_envelopes > 0) {
          itm.title += "|平峰";
          itm.color = "red";
        }

        return itm;
      });
      console.log(info.mode,data,'info.mode' )
      if (info.mode == "month") {
        this.monthEvents = data;
        console.log(data,'data1' )
      } else {
        this.dayEvents = data;
        console.log(data,'data2' )
      }
    }else{
      this.dayEvents = [];
    }
  }

  async loadEventsCount(info: any) {
    const res = await this.$store.dispatch("stadium/groundEventsCount", {
      stadium_id: this.stadiumId,
      start_time: moment(info.start).format("YYYY-MM-DD HH:mm:ss"),
      end_time: moment(info.end).format("YYYY-MM-DD HH:mm:ss"),
      mode: info.mode
    });
    console.log(res.Data,'6666')
    if (res && res.Data) {
      this.monthEvents = res.Data;
    }
  }

  async loadData11() {
    this.spinLoading = true;
    // 加载指定日期的订场情况
    await this.loadEvents({
      start: moment(this.curdate).startOf("day"),
      end: moment(this.curdate).endOf("day"),
      mode: "day"
    });

    // console.log(moment().calendar());

    // 加载指定月份的订场情况
    const days: any = this.calendarDate(this.curdate);

    await this.loadEventsCount({
      start: moment(days[0]).startOf("day"),
      end: moment(days[1]).endOf("day")
    });

    this.spinLoading = false;
  }

  async mounted() {
    // this.calendarDate(moment().format("YYYY-MM-DD"));
    // 加载
    let that = this;
    await this.loadStadiumSettings();

    // 加载片场
    const res = await that.$store.dispatch("stadium/getStadiumGrounds", {
      stadium_id: that.stadiumId
    });
    if (res && res.Data) {
      that.stadiumGrounds1 = res.Data;
    }

    // 加载指定日期的订场情况
    await that.loadData11();

  }

  selectDate(date: any) {
    // console.log(date);
    this.curdate = date.format("YYYY-MM-DD");

    this.loadData11();
  }

  onPanelChange(value: any, mode: string) {
    // eslint-disable-next-line no-console
    // console.log(value);
    // console.log(mode);
    if (mode == "year") {
      this.loadEventsCount({
        start: value.startOf("year").format("YYYY-MM-DD HH:mm:ss"),
        end: value.endOf("year").format("YYYY-MM-DD HH:mm:ss"),
        mode
      });
    } else {
      // console.log(date);
      this.curdate = value.format("YYYY-MM-DD");
      this.loadData11();
    }
  }

  renderStatus(groundId: number, hourFrom: number, minFrom: number, hourTo: number, minTo: number) {
    // console.log(this.events);
    // console.log(this.curdate);

    // console.log
    const obj: any = _.find(this.dayEvents, o => {
      const start = `${moment(o.start).format("YYYY-MM-DD HH")}:${minFrom == 0 ? "00" : "30"}:00`;

      const end = `${moment(o.end).format("YYYY-MM-DD HH")}:${minTo == 0 ? "00" : "30"}:00`;

      if (hourTo == 24) {
        return (
          o.resourceId == groundId &&
          start ==
            `${this.curdate} ${hourFrom >= 10 ? hourFrom : `0${hourFrom}`}:${
              minFrom == 0 ? "00" : "30"
            }:00` &&
          end ==
            `${moment(this.curdate)
              .add(1, "day")
              .format("YYYY-MM-DD")} 00:00:00`
        );
      }
      return (
        o.resourceId == groundId &&
        start ==
          `${this.curdate} ${hourFrom >= 10 ? hourFrom : `0${hourFrom}`}:${
            minFrom == 0 ? "00" : "30"
          }:00` &&
        end ==
          `${this.curdate} ${hourTo >= 10 ? hourTo : `0${hourTo}`}:${minTo == 0 ? "00" : "30"}:00`
      );
    });

    return obj;
  }

  renderDayData(value: any) {
    // console.log(this.monthEvents);
    // console.log(value.format("YYYY-MM-DD"));
    const obj: any = _.find(this.monthEvents, o => o.time_date_day == value.format("YYYY-MM-DD"));

    // console.log(obj);

    if (obj) {
      return `<div><span class="ant-badge ant-badge-status ant-badge-not-a-wrapper">
        <span class="ant-badge-status-dot ant-badge-status-red"></span>
        <span class="ant-badge-status-text">占场：${obj.take_up_count}</span>
      </span></div>
      <div><span class="ant-badge ant-badge-status ant-badge-not-a-wrapper">
        <span class="ant-badge-status-dot ant-badge-status-purple"></span>
        <span class="ant-badge-status-text">包场：${obj.block_count}</span>
      </span></div>
      <div><span class="ant-badge ant-badge-status ant-badge-not-a-wrapper">
        <span class="ant-badge-status-dot ant-badge-status-green"></span>
        <span class="ant-badge-status-text">订场：${obj.order_count}</span>
      </span></div>`;
    }

    return "";
  }

  getMonthData(value: any) {
    const obj: any = _.find(this.monthEvents, o => o.d == value.format("YYYY-MM"));

    if (obj) {
      return `<div><span class="ant-badge ant-badge-status ant-badge-not-a-wrapper">
        <span class="ant-badge-status-dot ant-badge-status-red"></span>
        <span class="ant-badge-status-text">占场：${obj.take_up_count}</span>
      </span></div>
      <div><span class="ant-badge ant-badge-status ant-badge-not-a-wrapper">
        <span class="ant-badge-status-dot ant-badge-status-purple"></span>
        <span class="ant-badge-status-text">包场：${obj.block_count}</span>
      </span></div>
      <div><span class="ant-badge ant-badge-status ant-badge-not-a-wrapper">
        <span class="ant-badge-status-dot ant-badge-status-green"></span>
        <span class="ant-badge-status-text">订场：${obj.order_count}</span>
      </span></div>`;
    }
    return "";
  }
}
